/**
 * Runs `task` under an AbortController tied to one effect's lifetime.
 *
 * The returned value is the effect's cleanup. `settle` applies its argument only while the task
 * still owns the effect, so a result arriving after the effect was abandoned is dropped.
 */
export function abortableTask(
    task: (
        signal: AbortSignal,
        settle: (apply: () => void) => void
    ) => Promise<void>
): () => void {
    const controller = new AbortController();
    const settle = (apply: () => void) => {
        if (!controller.signal.aborted) {
            apply();
        }
    };
    void task(controller.signal, settle);
    return () => controller.abort();
}
